import DataTable from "../../../components/common/data-table/data-table";
import { BADGE_COLUMNS } from "./badge-column";
import BadgeForm from "./badge-form";
import { ASSETS_API, ASSETS_API_PREFIX } from "config-global";

interface BadgeProps {}

const Badge: React.FC<BadgeProps> = () => {
  const transformType = (type: number) => {
    switch (type) {
      case 0:
        return "General";
      case 1:
        return "Daily";
      case 2:
        return "Weekly";
      default:
        return type;
    }
  };

  return (
    <div>
      <DataTable
        tableName="Badge"
        parentTableName="Management"
        deleteTitle="Badge"
        mainCol="title"
        getAllLink="/api/admin/tasks/" //TODO add "api" to base rout
        getItemLink="/api/admin/tasks" //TODO add "api" to base rout
        hasEdit={true}
        hasCreate={true}
        hasDelete={true}
        updateItemLink="/api/admin/tasks" //TODO add "api" to base rout
        createItemLink="/api/admin/tasks" //TODO add "api" to base rout
        deleteRowLink="/api/admin/tasks" //TODO add "api" to base rout
        tableCols={BADGE_COLUMNS}
        FormContent={BadgeForm}
        tableDataMapper={(rows) => {
          return rows?.map((row: any, index: number) => {
            return {
              ...row,
              type: transformType(row.type),
            };
          });
        }}
        formDataMapper={(data: any) => {
          const translationAr = data.translations.find(
            (translation: any) => translation.locale === "ar"
          );
          const translationEn = data.translations.find(
            (translation: any) => translation.locale === "en"
          );

          return {
            ...data,
            title: translationEn?.title,
            titleAr: translationAr?.title,
            description: translationEn?.description,
            descriptionAr: translationAr?.description,
            coverImage: ASSETS_API + ASSETS_API_PREFIX + data?.coverImageUrl,
          };
        }}
        formSubmitMapper={(data: any) => {
          let description = "";
          let descriptionAr = "";
          switch (data.domain) {
            case 0:
              description = `Follow ${data.totalCount} Children`;
              descriptionAr = `تابع ${data.totalCount} أطفال`;
              break;
            case 1:
              description = `Create ${data.totalCount} Challenges`;
              descriptionAr = `انشئ ${data.totalCount} من التحديات`;
              break;
            case 2:
              description = `Give ${data.totalCount} Likes`;
              descriptionAr = `امنح ${data.totalCount} لايك`;
              break;
            case 3:
              description = `Add ${data.totalCount} Comments`;
              descriptionAr = `اضف ${data.totalCount} من التعليقات`;
              break;
            case 4:
              description = `Do ${data.totalCount} Challenges`;
              descriptionAr = `انجز ${data.totalCount} تحديات`;
              break;
            case 5:
              description = `Create ${data.totalCount} Story`;
              descriptionAr = `انشئ ${data.totalCount} من الستوريات`;
              break;
            case 6:
              description = `Give ${data.totalCount} Likes`;
              descriptionAr = `امنح ${data.totalCount} لايك`;
              break;
            // Add other cases here if needed
            default:
              description = "Default description"; // Set a default value if needed
              descriptionAr = "الوصف الافتراضي"; // Arabic translation for default description
              break;
          }
          const formData = new FormData();
          formData.append("translations[0][locale]", "en");
          formData.append("translations[0][title]", data.title);
          formData.append("translations[1][locale]", "ar");
          formData.append("translations[1][title]", data.titleAr);
          formData.append("translations[0][description]", description);
          formData.append("translations[1][description]", descriptionAr);
          formData.append("type", data.type.toString());
          formData.append("domain", data.domain.toString());
          formData.append("totalCount", data.totalCount.toString());
          if (!data?.id && data?.coverImage) {
            formData.append("coverImage", data.coverImage); // Assuming coverImage is a File object
          }
          return formData;
        }}
      />
    </div>
  );
};

export default Badge;
